import React from 'react';
import ContactForm, { CONTACT_FORM_CLASSES } from '../ContactForm/ContactForm';
import './homepage.css';

const ContactSection = () => (
  <section className="hp-contact">
    <div className="hp-contact__inner">
      <div className="hp-contact__left">
        <h2 className="hp-contact__heading">
          Have a question?<br />Drop us a line!
        </h2>
      </div>
      <ContactForm
        idPrefix="hp-contact"
        classNames={CONTACT_FORM_CLASSES.home}
      />
    </div>
  </section>
);

export default ContactSection;
